export default __webpack_public_path__ + "static/media/sweeney.fab8741b.jpg";